import React, { useContext, useEffect } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import LoadingContext from '../context/loading.context';
import NotificationContext from '../context/notification.Context';
import Devices from './Devices';
import * as Constants from '../modules/constants';


function Locations(props) {

    const { userId, token, setUserDetails } = useContext(UserDetailsContext);

    const { locations, activeLocationId, setLocations, setActiveLocationId } = useContext(LocationsContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { setServerUnreachable } = useContext(NotificationContext);

    const apiHostName = Constants.API_URL;

    // Get a list of locations from the API:

    useEffect(() => {
        // Write changes to LocalStorage, so it's preserved over multiple calls:
        // Get up-to-date data from the server:
        showLoading();
        fetch(apiHostName + '/v1/locations/?userId=' + userId, {
            mode: "cors",
            method: 'GET', headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (response.status === 401) {
                    // Not authorized --> empty user details, so we get redirected to login page
                    setUserDetails({ userName: '', email: '', userLocation: { name: '', id: 0 }, token: '' });
                    var error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
                else if (!response.ok) {
                    throw new Error ("Invalid network response");
                }
                setServerUnreachable(false);
                return response.json();
            })
            .then(function (json) {
                setLocations({ newLocations: json });        // And update context value, so it's stored in LocalStorage as well.
                if (!activeLocationId) {
                    if (Object.values(json).length > 0)
                        setActiveLocationId(Object.values(json)[0].id);
                }
                else {
                    // Check if this location ID is still valid:
                    if (!json[activeLocationId])
                        if (Object.values(json).length > 0)
                            setActiveLocationId(Object.values(json)[0].id);
                }
                hideLoading();
            })
            .catch(error => {
                setServerUnreachable(true);
                console.error(error);
                hideLoading();
            });
    }, [userId, apiHostName, token, setLocations, activeLocationId, showLoading, hideLoading, setActiveLocationId, setUserDetails]);


    return (
        <React.Fragment>

            {locations &&
                <Devices />
            }
        </React.Fragment>
    );
}

export default Locations;


// WEBPACK FOOTER //
// ./src/components/Locations.js